import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';

import {AwsService} from "../aws.service";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private _awsService: AwsService) {
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this._awsService.expired) {
            return true;
        } else {
            let refreshed: boolean = await this._awsService.refresh();
            if (refreshed) return true;
            this.router.navigate(['/signin'], {queryParams: {returnUrl: state.url}});
            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/auth/auth.guard.ts